import { BaseFiltroPagDTO, BaseLogDTO, IdNomeDTO } from './base-dto';

export class FiltroGrupoEnteralParmDTO extends BaseFiltroPagDTO {
  nome: string;
  ativo: Boolean;
}

export class GrupoEnteralListItemDTO {
  id: number;
  nome: string;
  alteradoPor: string;
  ultimaAlteracao: Date;
  ativo: Boolean;
}

export class GrupoEnteralDetalheDTO extends BaseLogDTO {
  id: number;
  nome: string;
  ativo: Boolean;
}

export class GrupoEnteralParmDTO {
  id: number;
  nome: string;
  ativo: Boolean;
}

export class FiltroProdutoEnteralParmDTO extends BaseFiltroPagDTO {
  nome: string;
  ativo: Boolean;
  idGrupo: Number;
  nomeFabricante: string;
}

export class ProdutoEnteralListItemDTO {
  id: number;
  nome: string;
  nomeGrupo: string;
  nomeFabricante: string;
  ativo: Boolean;
  alteradoPor: string;
  ultimaAlteracao: Date;
}

export class ProdutoEnteralDetalheDTO extends BaseLogDTO {
  id: number;
  nome: string;
  ativo: boolean;
  grupo: IdNomeDTO;
  nomeFabricante: string;
  tiposPacientes: string[];
  caloriasTotal: number;
  quantidadeReferencia: number;
  insumos: InsumoEnteralDetalheDTO[] = [];
}

export class InsumoEnteralDetalheDTO extends BaseLogDTO {
  id: number;
  idInsumo: number;
  codInsumo: string;
  nomeInsumo: string;
  quantidade: number;
  nomeUnidadeMedida: string;
}

export class InsumoEnteralParmDTO {
  idInsumo: number;
  quantidade: number;
}

export class ProdutoEnteralParmDTO {
  id: number;
  nome: string;
  ativo: boolean;
  idGrupo: number;
  nomeFabricante: string;
  tiposPaciente: string[];
  caloriasTotal: number;
  quantidadeReferencia: number;
  insumos: InsumoEnteralParmDTO[];
}
